/* =============================================
   MEGA MYSTERY BOX COMPANY — THEME JS
   ============================================= */

const MMB = (() => {
  'use strict';

  /* ── CART ── */
  let cartData = { items: [], item_count: 0, total_price: 0 };

  async function fetchCart() {
    try {
      const res = await fetch('/cart.js');
      cartData = await res.json();
      renderCart();
    } catch(e) { console.warn('Cart fetch failed', e); }
  }

  async function addToCart(variantId, qty = 1, properties = {}) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty, properties })
      });
      const data = await res.json();
      if (data.status) { showToast('⚠️ ' + (data.description || 'Could not add to cart')); return; }
      await fetchCart();
      openCart();
      showToast('🎁 ' + data.product_title + ' added to cart!');
    } catch(e) { showToast('⚠️ Something went wrong'); }
  }

  async function changeQty(lineIndex, qty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: lineIndex, quantity: qty })
      });
      await fetchCart();
    } catch(e) { console.warn(e); }
  }

  function formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  function renderCart() {
    const count = cartData.item_count || 0;
    const countEl = document.getElementById('cart-count');
    if (countEl) countEl.textContent = count;

    const listEl = document.getElementById('cart-items-list');
    const footerEl = document.getElementById('cart-footer');
    const totalEl = document.getElementById('cart-total-display');

    if (!listEl) return;

    if (!cartData.items || cartData.items.length === 0) {
      listEl.innerHTML = '<p class="cart-empty">Your cart is empty 😢</p>';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    if (footerEl) footerEl.style.display = 'block';
    if (totalEl) totalEl.textContent = formatMoney(cartData.total_price);

    listEl.innerHTML = cartData.items.map((item, i) => {
      const props = item.properties ? Object.entries(item.properties)
        .filter(([k,v]) => v && !k.startsWith('_'))
        .map(([k,v]) => `${k}: ${v}`).join(' · ') : '';
      const img = item.image
        ? `<img src="${item.image}" alt="${item.title}" loading="lazy">`
        : `<span>${item.product_type === 'Mystery Box' ? '🎁' : '📦'}</span>`;
      return `<div class="cart-item">
        <div class="cart-item-img">${img}</div>
        <div class="cart-item-info">
          <div class="cart-item-name">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item-props">${item.variant_title}</div>` : ''}
          ${props ? `<div class="cart-item-props">${props}</div>` : ''}
          <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
        </div>
        <div class="qty-ctrl">
          <button class="qty-btn" onclick="MMB.changeQty(${i+1}, ${item.quantity - 1})" aria-label="Decrease">−</button>
          <span class="qty-num">${item.quantity}</span>
          <button class="qty-btn" onclick="MMB.changeQty(${i+1}, ${item.quantity + 1})" aria-label="Increase">+</button>
        </div>
        <button class="cart-remove" onclick="MMB.changeQty(${i+1}, 0)" aria-label="Remove item">🗑</button>
      </div>`;
    }).join('');
  }

  function openCart() {
    document.getElementById('cart-overlay')?.classList.add('is-open');
    document.getElementById('cart-drawer')?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCart() {
    document.getElementById('cart-overlay')?.classList.remove('is-open');
    document.getElementById('cart-drawer')?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* ── TOAST ── */
  let toastTimer;
  function showToast(msg, icon = '') {
    const toast = document.getElementById('toast');
    const msgEl = document.getElementById('toast-msg');
    const iconEl = document.getElementById('toast-icon');
    if (!toast || !msgEl) return;
    if (iconEl) iconEl.textContent = icon || '✅';
    msgEl.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 3500);
  }

  /* ── MOBILE NAV ── */
  function initMobileNav() {
    const toggle = document.getElementById('menu-toggle');
    const mobileNav = document.getElementById('mobile-nav');
    if (!toggle || !mobileNav) return;
    toggle.addEventListener('click', () => {
      const open = mobileNav.style.display === 'block';
      mobileNav.style.display = open ? 'none' : 'block';
    });
  }

  /* ── BOX BUILDER ── */
  const builder = {
    step: 1,
    fandoms: [],
    boxSize: 'Standard',
    price: 34.99,
    budget: 50,
    msgIncluded: true,

    goToStep(n) {
      for (let i = 1; i <= 4; i++) {
        const panel = document.getElementById('builder-panel-' + i);
        const tab = document.getElementById('builder-tab-' + i);
        if (panel) panel.classList.toggle('is-active', i === n);
        if (tab) {
          tab.classList.remove('is-active', 'is-done');
          if (i === n) tab.classList.add('is-active');
          else if (i < n) tab.classList.add('is-done');
        }
      }
      this.step = n;
      if (n === 4) this.updateSummary();
    },

    toggleFandom(el, name) {
      const idx = this.fandoms.indexOf(name);
      if (idx > -1) {
        this.fandoms.splice(idx, 1);
        el.classList.remove('is-selected');
      } else if (this.fandoms.length < 3) {
        this.fandoms.push(name);
        el.classList.add('is-selected');
      } else {
        showToast('⚠️ Maximum 3 fandoms — deselect one first');
      }
    },

    selectSize(el, size, items, price) {
      document.querySelectorAll('#builder-panel-2 .option-btn').forEach(b => b.classList.remove('is-selected'));
      el.classList.add('is-selected');
      this.boxSize = size;
      this.items = items;
      this.price = parseFloat(price);
    },

    setBudget(v) {
      this.budget = parseInt(v);
      const el = document.getElementById('builder-budget-val');
      if (el) el.textContent = '£' + v;
    },

    setMsg(yes) {
      this.msgIncluded = yes;
      document.getElementById('builder-msg-yes')?.classList.toggle('is-selected', yes);
      document.getElementById('builder-msg-no')?.classList.toggle('is-selected', !yes);
      const input = document.getElementById('builder-msg-input');
      if (input) input.style.display = yes ? 'block' : 'none';
    },

    updateSummary() {
      const boxEl = document.getElementById('sum-box');
      const fandomsEl = document.getElementById('sum-fandoms');
      const budgetEl = document.getElementById('sum-budget');
      const totalEl = document.getElementById('sum-total');
      if (boxEl) boxEl.textContent = this.boxSize + ' Box (' + (this.items || '5–8 items') + ')';
      if (fandomsEl) fandomsEl.textContent = this.fandoms.length ? this.fandoms.join(', ') : 'Not selected';
      if (budgetEl) budgetEl.textContent = '£' + this.budget;
      if (totalEl) totalEl.textContent = '£' + this.price.toFixed(2);
    },

    addToCart() {
      const variantId = document.getElementById('builder-variant-id')?.value;
      if (!variantId) {
        showToast('⚠️ Custom Box product not found. Please set up the product in Shopify admin.');
        return;
      }
      const name = document.getElementById('recipient-name')?.value || '';
      const message = document.getElementById('gift-message')?.value || '';
      const properties = {
        'Box Size': this.boxSize,
        'Fandoms': this.fandoms.join(', ') || 'Mixed',
        'Budget': '£' + this.budget,
      };
      if (name) properties['Recipient'] = name;
      if (this.msgIncluded && message) properties['Gift Message'] = message;
      addToCart(variantId, 1, properties);
    }
  };

  /* ── HERO PARTICLES ── */
  function initParticles() {
    const container = document.getElementById('hero-particles');
    if (!container) return;
    for (let i = 0; i < 8; i++) {
      const el = document.createElement('div');
      el.className = 'particle';
      const colors = ['var(--gold)', '#a78bfa', 'var(--gold-light)'];
      el.style.cssText = [
        `left:${20 + Math.random() * 60}%`,
        `top:${20 + Math.random() * 60}%`,
        `animation-delay:${(Math.random() * 3).toFixed(1)}s`,
        `animation-duration:${(2 + Math.random() * 2).toFixed(1)}s`,
        `--tx:${Math.round((Math.random() - 0.5) * 80)}px`,
        `--ty:${Math.round((Math.random() - 0.5) * 80)}px`,
        `background:${colors[Math.floor(Math.random() * colors.length)]}`
      ].join(';');
      container.appendChild(el);
    }
  }

  /* ── ADD TO CART FORMS ── */
  function initProductForms() {
    document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const variantId = btn.dataset.variantId || btn.closest('form')?.querySelector('[name="id"]')?.value;
        if (!variantId) { showToast('⚠️ Variant not found'); return; }
        btn.textContent = 'Adding…';
        btn.disabled = true;
        await addToCart(variantId, 1);
        btn.textContent = btn.dataset.label || '🛒 Add to Cart';
        btn.disabled = false;
      });
    });

    document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const variantInput = form.querySelector('[name="id"]');
        const qtyInput = form.querySelector('[name="quantity"]');
        if (!variantInput) return;
        const btn = form.querySelector('[type="submit"]');
        const original = btn?.textContent;
        if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }
        await addToCart(variantInput.value, qtyInput ? parseInt(qtyInput.value) : 1);
        if (btn) { btn.textContent = original || 'Add to Cart'; btn.disabled = false; }
      });
    });
  }

  /* ── INIT ── */
  function init() {
    fetchCart();
    initMobileNav();
    initParticles();
    initProductForms();

    // Close cart on ESC
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') closeCart();
    });
  }

  document.addEventListener('DOMContentLoaded', init);

  return { openCart, closeCart, showToast, addToCart, changeQty, builder };
})();
